<template>
  <div>
    <el-dialog class="wp90 h800" :model-value="openList" :close-on-click-modal="false" :show-close="false" destroy-on-close>
      <template #header>
        <div class="header-left">
          <el-icon class="header-icon">
            <Suitcase />
          </el-icon>
          <span class="header-title">制章管理</span>
        </div>
        <div class="header-right">
          <el-button type="info" text @click="openList=false;homeCloseWindow('openReturn', emits, false)">
            <el-icon>
              <Close />
            </el-icon>
          </el-button>
        </div>
      </template>
      <div class="list-page pl0 pr0 pt0 pb0">
        <el-container>
          <el-header>
            <!-- 搜索区域 BEGIN -->
            <el-form class="search-box" :model="dataGrid.parms" @submit.enter.prevent>

              <el-form-item >
                <el-input placeholder="公章编号" class="filter-item" v-model="dataGrid.parms.gzbh" clearable />
              </el-form-item>
              <el-button type="success" @click="bindTable()"><span class="el-icon--left iconfont icon-sousuo"></span>查询</el-button>
            </el-form>
            <!-- 搜索区域 END -->
            <!-- 按钮区域 BEGIN -->
            <div class="button-box">
              <el-button type="primary" @click="openAdd=true"><span class="iconfont icon-chuangjian"></span>添加</el-button>
              <el-button type="warning" @click="remove()"><span class="iconfont icon-shanchu"></span>批量删除</el-button>
            </div>
            <!-- 按钮区域 END -->
          </el-header>
          <el-main>
            <el-table :data="dataGrid.data" :default-sort="dataGrid.orderBy" v-loading="dataGrid.loading" @sort-change="dataGrid.sortChange" @selection-change="dataGrid.selectionChange" height="100%" border stripe>
              <!-- 冻结列-Left BEGIN -->
              <el-table-column type="selection" width="55" align="center" />
              <el-table-column label="序号" type="index" width="80" fixed align="center" />
              <!-- 冻结列-Left END -->
              <el-table-column label="公章编号" prop="gzbh" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
              <el-table-column label="制章名称" prop="zzmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
              <el-table-column label="保管单位名称" prop="bgdwmc" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
              <el-table-column label="保管人" prop="bgrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
              <el-table-column label="批准单位" prop="pzdw" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
              <el-table-column label="批准人" prop="pzrxm" align="center" show-overflow-tooltip sortable :sort-orders="['ascending', 'descending']"/>
              <!-- 冻结列-Right BEGIN -->
              <el-table-column label="操作" width="180" fixed="right" align="center">
                <template #default="scope">
                  <el-button link type="success" @click="openDetail=true; row=scope.row">详情</el-button>
                  <el-button link type="primary" @click="openEdit=true; row=scope.row">修改</el-button>
                  <el-button link type="warning" @click="dataGrid.multipleSelection=[scope.row.id]; remove()">删除</el-button>
                </template>
              </el-table-column>
              <!-- 冻结列-Right END -->
            </el-table>
          </el-main>
          <el-footer>
            <pagination :pagination="dataGrid.pagination" @ReturnData="bindTable" />
          </el-footer>
        </el-container>
      </div>
    </el-dialog>
  </div>
  <add v-if="openAdd" v-model:openAdd="openAdd" @ReturnData="bindTable" />
  <edit v-if="openEdit" v-model:openEdit="openEdit" :row="row" @ReturnData="bindTable" />
  <detail v-if="openDetail" v-model:openDetail="openDetail" :row="row" />
</template>

<script setup>
import { ref, watch } from 'vue'
import { loadList, submitDataGridAction, homeCloseWindow } from '@/api/common.js'
import pagination from '@/components/pagination.vue'
import add from './add.vue'
import edit from './edit.vue'
import detail from './detail.vue'

const props = defineProps({ open: { type: String, required: true }, row: { type: Object, required: false } })
const emits = defineEmits(['openReturn', 'ReturnData'])

const dataGrid = ref({
  parms: {},
  data: [],
  pagination: {},
  loading: false,
  orderBy: { prop: 'zzmc', order: 'ascending' },
  multipleSelection: [],
  sortChange: function (column) {
    dataGrid.value.orderBy.prop = column.prop
    dataGrid.value.orderBy.order = column.order
    bindTable()
  },
  selectionChange: function (selection) {
    dataGrid.value.multipleSelection = selection.map(item => (item.id))
  }
})
const bindTable = async (pageNo, pageSize) => {
  loadList({
    url: '/api/v2/bangong/bangongzhizhangguanli/pagelist',
    pageNo: pageNo || 1,
    pageSize: pageSize || 100,
    dataGrid: dataGrid.value,
    loadSuccess: function () {
      dataGrid.value.multipleSelection = []
    }
  })
}

// 弹窗
const row = ref()
const openAdd = ref(false)
const openEdit = ref(false)
const openDetail = ref(false)
const openList = ref(false)

// 删除
const remove = async () => {
  submitDataGridAction({
    url: '/api/v2/bangong/bangongzhizhangguanli',
    dataGrid: dataGrid.value,
    confirmTitle: '确定要删除吗?',
    method: 'delete',
    callback: function () {
      bindTable()
    }
  })
}

watch(
  () => props.open,
  () => {
    if (props.open === 'zhizhangguanli') {
      openList.value = true
      bindTable()
    } else {
      openList.value = false
    }
  },
  { deep: true, immediate: true }
)

</script>
